import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { AuthProvider } from '../auth/auth';

import OneSignal from 'onesignal-cordova-plugin';

@Injectable()
export class PushNotificationProvider {

  constructor(
    private platform: Platform,
    private authProvider: AuthProvider) { }

  init() {
    if (this.platform.is('cordova')) {
      console.log("Iniciano push")
      this._init();
    }
  }

  private async _init() {
    // this.oneSignal.startInit('0ea99b35-3aef-4437-b082-04f84acc2bcc', '14624641042');

    OneSignal.setAppId('0ea99b35-3aef-4437-b082-04f84acc2bcc');

    OneSignal.setNotificationOpenedHandler(function (jsonData) {
      console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
    });

    
    OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
      console.log("User accepted notifications: " + accepted);
    });

    
    OneSignal.getDeviceState((response) => {
      if (!response.hasNotificationPermission) {
        OneSignal.addTrigger("showPrompt", "true")
        return;
      } 

      this.authProvider.getSession()
        .then(jugador => {
          if (jugador) {
            console.log(JSON.stringify(response))
            this.authProvider.updatePlayerId(jugador._id, response.userId);
          }
        })
        .catch(e => {
          console.error(JSON.stringify(e))
        });
    })


    // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);

    // this.oneSignal.handleNotificationReceived().subscribe(() => {
    //  // do something when notification is received
    // });

    // this.oneSignal.handleNotificationOpened().subscribe(() => {
    //   // do something when a notification is opened
    // });

    // this.oneSignal.endInit();

    // this.oneSignal.getIds().then((id) => {
    //   this.authProvider.getSession()
    //     .then( jugador => {
    //       console.log(JSON.stringify(jugador))
    //       if(jugador) {
    //           this.authProvider.updatePlayerId(jugador._id, id.userId);
    //       }
    //     })
    //     .catch( e => {
    //       console.error(JSON.stringify(e))
    //     });
    // });
  }

}



// WEBPACK FOOTER //
// ./src/providers/push-notification/push-notification.ts